module.exports = __webpack_public_path__ + "img/paying-user.17da2338.svg";